"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var getSize = function getSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};
var useWindowSize = function useWindowSize() {
  var _useState = (0, _react.useState)(getSize),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    windowSize = _useState2[0],
    setSize = _useState2[1];
  var handleResize = (0, _react.useCallback)(function () {
    return setSize(getSize());
  }, []);
  _react.default.useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  return windowSize;
};
exports.useWindowSize = useWindowSize;